import * as styles from './index.css';
import RichTranslation from '@blueshift-ui/i18n/dist/components/rich-translation';
import Typography from '@blueshift-ui/theme/dist/components/typography';
import { format } from 'date-fns';
import useRichTranslation from '@blueshift-ui/i18n/dist/hooks/use-rich-translation';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

interface ConfirmCancellationStepProps {
  nextBillingDate: string;
}

function ConfirmCancellationStep({ nextBillingDate }: ConfirmCancellationStepProps) {
  const { translate } = useTranslation('cancel_membership_page.confirm');
  const { translate: richTranslate } = useTranslation('cancel_membership_page.confirm', {
    rich: true,
  });

  return (
    <article>
      <section className={styles.heading}>
        <Typography component="h1" variant="h5">
          {translate('heading_1')}
        </Typography>
        <Typography component="h2" variant="subtitle2">
          {translate('heading_2', {
            next_billing_date: format(new Date(nextBillingDate), 'MMMM d, yyyy'),
          })}
        </Typography>
        <Typography component="h3" variant="body2">
          {translate('heading_3')}
        </Typography>
      </section>
      <Typography className={styles.entitlements} component="section">
        <RichTranslation i18nKey="lost_entitlements" translator={richTranslate} />
      </Typography>
    </article>
  );
}

export default ConfirmCancellationStep;
